module.exports = __webpack_public_path__ + "static/img/toast_success.c22dd3be.svg";